/* eslint-disable sort-exports/sort-exports */
export const CONTEXT_ACCREDITATION_CODE = 'accreditation'
export const CONTEXT_ACCREDITATION_PASSPORT_CODE = 'accreditation-passport'
export const CONTEXT_TRAINING_WISH_CODE = 'training-wish'

export interface DocTemplateContext {
  code: string
  sections?: string[]
  permission?: string
  requiresSafety?: boolean
  canRepeat: boolean
  hasDefault: boolean
}

export const CONTEXTS: DocTemplateContext[] = [
  {
    code: 'session',
    sections: ['session', 'training', 'period', 'participant', 'block', 'day', 'format'],
    canRepeat: true,
    hasDefault: false,
  },
  {
    code: CONTEXT_TRAINING_WISH_CODE,
    sections: ['session', 'training', 'participant', 'format'],
    canRepeat: false,
    hasDefault: true,
  },
  {
    code: CONTEXT_ACCREDITATION_CODE,
    permission: 'ACCREDITATION_MANAGEMENT',
    sections: ['participant', 'accreditation', 'format'],
    canRepeat: true,
    hasDefault: true,
  },
  {
    code: CONTEXT_ACCREDITATION_PASSPORT_CODE,
    requiresSafety: true,
    canRepeat: false,
    hasDefault: true,
  },
  {
    code: 'room-booking-sheet',
    canRepeat: false,
    hasDefault: true,
  },
  {
    code: 'room-booking-planning',
    canRepeat: false,
    hasDefault: true,
  },
]
export const FORMAT_PDF = 'pdf'
export const FORMATS = ['docx', FORMAT_PDF]
export const REPEAT_MODE_DAY = 'day'
export const REPEAT_MODE_NEVER = 'never'
export const REPEAT_MODE_PARTICIPANT = 'participant'
export const REPEAT_MODE_PERIOD = 'period'

export const REPEAT_MODES = [REPEAT_MODE_NEVER, REPEAT_MODE_PARTICIPANT, REPEAT_MODE_DAY, REPEAT_MODE_PERIOD]
